import * as React from 'react';
import type { PersonOwner } from '../../state/editor';
import { OwnerPersonForm } from '../OwnerPersonForm';
import { BoxHeading } from '../box';
import { EditItem } from './EditItem';

interface Props {
  owner: PersonOwner;
  onDone: () => void;
}

export const EditPersonItem: React.FC<Props> = props => {
  return (
    <EditItem>
      <BoxHeading>Endre detaljer</BoxHeading>
      <OwnerPersonForm
        initialPerson={props.owner.item}
        onDone={props.onDone}
        editType="edit"
      />
    </EditItem>
  );
};
